import React from 'react';
import {SwiperProps, SwiperRef} from "swiper/swiper-react";
import {Swiper} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/virtual';

export const SwiperComponent: React.FC<SwiperProps> = React.forwardRef<SwiperRef, SwiperProps>((props, ref) => {
    return (
        <Swiper {...props} ref={ref}/>
    );
})
